






































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import bus from "@/main";
import {Api} from "@/core/services/MedicaPro/Api";
import {User} from "@/core/services/MedicaPro/models";

@Component({
    components: {}
})
export default class UserItemEdit extends Vue {

    @Prop() itemId?: number;
    public item?: any;
    public dialog = false;
    public valid = false;
    public rules = {
        name: [(v: any) => !!v || 'Name is required'],
        password: [(v: string) => !v || v.length > 6 || 'Password must be at least 6 characters long'],
    }
    public password = '';
    public passwordConfirm = '';

    public mounted() {
        this.loadItem();
    }

    public save() {
        if (this.valid) {
            const API = this.item?.exists() ? Api.users().patchById(this.itemId!) : Api.users().post();
            this.item!.scope = this.item!.scopes.join(' ');
            if (this.password?.length >= 6 && this.password.localeCompare(this.passwordConfirm) === 0) {
                this.item.password = this.password;
            }
            API.save(this.item!, item => {
                this.dialog = false;
                this.$toast(`Bruger ${item.name} gemt`, {
                    color: 'green',
                    dismissable: true
                })
                bus.$emit('userSaved', item);
            });
        }
    }

    @Watch('itemId')
    private loadItem() {
        if (this.itemId == null) {
            // Ignore
        } else if (this.itemId == 0) {
            this.item = new User();
            this.dialog = true;
        } else if (this.itemId > 0) {
            Api.users().getById(this.itemId).find(item => {
                this.item = item[0];
                this.item.scopes = this.item.scope?.split(' ') ?? [];
                this.dialog = true;
            });
        }
    }

    public close() {
        this.dialog = false;
    }

}
